// extracted by mini-css-extract-plugin
export default {"reservation_item__form":"user-edit-form_reservation_item__form__Kzp3R","reservation_item__form__action":"user-edit-form_reservation_item__form__action__LNI5q"};